<template>
  <div class="box">
    <p class="title is-5">
      Background Color
      <input type="color" v-on:change="pickerCallback" v-model="selectedColor">
    </p>
    <template v-for="color in presetColors">
      <button
        v-bind:class="['round', selectedColor === color ? 'selected' : '']"
        v-bind:style="`background-color: ${color}`"
        v-on:click="preselectedCallback(color)"
      />&nbsp;&nbsp;
    </template>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        selectedColor: '#f7f7f3',
        presetColors: [
          '#ffffff',
          '#fcfcfc',
          '#f7f7f3',
          '#e3e6e8',
        ]
      }
    },
    components: {
    },
    props: {
      color: String,
      callback: Function,
    },
    methods: {
      pickerCallback: function(event) {
        this.callback.call(this, event.target.value);
      },
      preselectedCallback: function(color) {
        this.selectedColor = color;
        this.callback.call(this, color);
      },
    },
    watch: {
      color: function() {
        this.selectedColor = this.color;
      }
    },
    created: function() {
      this.selectedColor = this.color;
    }
  }
</script>

<style scoped>
.round {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  border: 4px solid rgba(0, 0, 0, 0.25);
}
input[type=color] {
  height: 1.5rem;
  margin-left: 0.5rem;
  position: relative;
  top: -4px;
}
button.round.selected {
  border: 4px solid #000;
}
</style>
